import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { apisHeaders } from "../utils";

export const getItems = createAsyncThunk(
  "getItems",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}/item/getItems`,
        data,
        apisHeaders
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const itemSliceDetails = createSlice({
  name: "itemSliceDetails",
  initialState: {
    items: [],
    itemLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getItems.pending, (state) => {
        state.itemLoading = true;
        state.error = null;
      })
      .addCase(getItems.fulfilled, (state, action) => {
        state.itemLoading = false;
        state.items = action.payload.data;
        state.error = null;
      })
      .addCase(getItems.rejected, (state, action) => {
        state.itemLoading = false;
        state.error = action.payload;
      });
  },
});

export default itemSliceDetails.reducer;
